import * as React from 'react';
import { clsx } from 'clsx';
import styles from './ProgressBar.module.css';
import { UIHeading4, UIText1 } from '../../../typography';
import { BACKGROUND_COLOR, PROGRESS_COLOR } from '../../constants';
import { normalizeNumber } from '../../../utils/normalizeNumber';
import { getColorProps, getBackgroundProps } from '../../../utils/getColorProps';

/**
 * @param value - текущий прогресс (по умолчанию от 0 до 100)
 * @param minValue - минимальное значение прогресса (по умолчанию 0)
 * @param maxValue - максимальное значение прогресса (по умолчанию 100)
 * @param showProgress - отображать ли значение прогресса
 * @param styleType - тип стиля прогресс-бара, может быть 'default' или 'bar'
 * @param title - заголовок прогресс-бара
 * @param bgColor - цвет фона прогресса, если не указан, используется стандарт
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=59471-6343)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ProgressBar = _ref => {
  var _getBackgroundProps$s, _getColorProps;
  let {
    value = 100,
    minValue = 0,
    maxValue = 100,
    showProgress = false,
    styleType = 'default',
    valueColor,
    title,
    bgColor
  } = _ref;
  const progress = normalizeNumber(value, minValue, maxValue) * 100;
  const sizeClass = styleType === 'bar' ? styles.sizeBar : styles.sizeDefault;
  const progressBgColor = bgColor ? (_getBackgroundProps$s = getBackgroundProps(bgColor).style) === null || _getBackgroundProps$s === void 0 ? void 0 : _getBackgroundProps$s.background : BACKGROUND_COLOR;
  const progressValueColor = valueColor ? (_getColorProps = getColorProps(valueColor)) === null || _getColorProps === void 0 || (_getColorProps = _getColorProps.style) === null || _getColorProps === void 0 ? void 0 : _getColorProps.color : PROGRESS_COLOR[styleType];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [(title || showProgress) && /*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [title && /*#__PURE__*/_jsx(UIHeading4, {
        textAlign: "left",
        children: title
      }), showProgress && /*#__PURE__*/_jsx(UIText1, {
        textAlign: "right",
        children: value
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: clsx(styles.progressBar, sizeClass),
      style: {
        background: progressBgColor
      },
      role: "progressbar",
      "aria-valuenow": progress,
      "aria-valuemin": minValue,
      "aria-valuemax": maxValue,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.progress,
        style: {
          width: "".concat(progress, "%"),
          background: progressValueColor
        }
      })
    })]
  });
};